import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { ExpiredSessionHandle } from '@percent/domain/iam'
import { Footer } from '@percent/partner-dashboard/common/components'

export function ExpiredSessionHandleContainer() {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const redirectRoute = `/signin${location.search}`

  const handleRedirect = useCallback(() => {
    navigate(redirectRoute)
  }, [navigate, redirectRoute])

  return (
    <ExpiredSessionHandle
      heading={t('typography.sessionHasExpired')}
      description={t('typography.loggedOutFromThisSession')}
      buttonText={t('button.signIn')}
      onButtonClick={handleRedirect}
      footer={<Footer />}
    />
  )
}
